module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	
	fox.registerWidget('Popup_Model_Subscription', {

		configure: function () {
			this.registerOptions('', {
				'!template': 'popup_model_subscription',
				widgets: {
					form: {
						widget: 'Form',
						loadValuesOnRun: false,
						formElements: {
							name: {
								element: '[name="name"]',
								autoApply: true,
								defaultValue: fox.utils.localStorage('getItem', 'localName')
							},
							email: {
								element: '[name="email"]',
								autoApply: true,
								validate: [{validator: 'regexp', options: {type: 'emailCaseInsensitive'}, message: 'Wrong email format'}],
								defaultValue: fox.utils.localStorage('getItem', 'localEmail')
							},
						},
						'methods.send': 'Portal_Model.subscribe',
						submit: {
							target: '.subscribe',
							event: 'click'
						},
						'hooks.onSubmit': fox.bind(function (values) {
							this.handleSubmit(values);
						}, this),
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							formWidget: '@parent',
							hangClassLocation: 'parentNode',
							requiredFields: ['name', 'email'],
							defaultValidator: [{
								validator: 'length',
								options: {min: 1},
								message: 'Cannot be empty'
							}]
						}
					},

					// successPopup: {
					// 	widget: 'Dialog',
					// 	'dialog.width': 370,
					// 	'!widgets.content.template': 'popup_model_subscription_success'
					// },

					// errorPopup: {
					// 	widget: 'Dialog',
					// 	'dialog.width': 370,
					// 	'!widgets.content.template': 'popup_model_subscription_error'
					// }
				},

				handleDom: {
					focus: {
						target: 'input',
						event: 'focus',
						callback: '_handleFocus'
					}
				},

				handleWom: {
					_handleFormValidation: {
						widget: '#form #validator',
						event: 'formNotValid',
						callback: '_handleFormValidation'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		deactivate: function () {
			this.data = {};

			fox.each(['#successPopup', '#errorPopup'], function (path){
				var cont = this.wom1(['@parent', '@parent', path, '#content'].join(' '));

				cont.setTemplateOptions({});
			}, this);

			this.callParent('deactivate', arguments);
		},

		addedToDom: function () {
			this.wom1('#form').loadValues();
		},

		toggleError: function (name, state, msg) {
			var elm = this.dom1('[name="' + name + '"]');
			var msgElm = fox.dom.selectFirst('.error-msg', elm.parentNode.parentNode);
			
			msg = msg || '';

			fox.dom[state ? 'addClass' : 'removeClass']('error', elm.parentNode);

			if (!fox.isEmpty(msg)) {
				msgElm.innerHTML = msg;
			}

			if (!state) {
				msgElm.innerHTML = '';
			}
		},

		_handleFormValidation: function (err, w) {
			fox.each(err.errorStack, function(arr, alias) {
				this.toggleError(alias, true, arr[0].message);
			}, this);
		},

		_handleFocus: function (el) {
			this.toggleError(el.name, false);
		},

		handleSubmit: function (values) {
			var api = this.wom1('#form')._getFormSendApi();

			values.id = this.data.id;

			api.psend(values)
				.then(fox.bind(this.onSubscribeResponse, this))
				.catch(fox.bind(function (res, performer, e) {
					console.error('subscribe api ' + e, res);
					
					if (res && res.params.answer.reason) {
						this.showErrorPopup(res.params.answer.reason);

						return;
					}

					this.showErrorPopup();

				}, this));

			this.dispatchEvent('submit', values);
		},

		onSubscribeResponse: function () {
			var name = this.dom1('[name="name"]').value;
			var email = this.dom1('[name="email"]').value;

			if (name) {
				fox.utils.localStorage('setItem', 'localName', name);
			}

			if (email) {
				fox.utils.localStorage('setItem', 'localEmail', email);
			}

			this.showSuccessPopup();
		},

		setModelData: function (data) {
			this.data = data;

			var name = fox.objectGet(this.data.data.success, 'stats.name');

			this.setTemplateOptions('modelName', name);
			this.render();

			fox.each(['#successPopup', '#errorPopup'], function (path){
				var cont = this.wom1(['@parent', '@parent', path, '#content'].join(' '));

				cont.setTemplateOptions('modelName', name);
				cont.render();
			}, this);

		},

		showErrorPopup: function (msg) {
			var popup = this.wom1('@parent @parent #errorPopup');

			if (msg) {
				popup.wom1('#content').setTemplateOptions('message', msg);
				popup.wom1('#content').render();
			}

			popup.show();
		},

		showSuccessPopup: function () {
			this.wom1('@parent @parent #successPopup').show();
		}
	});

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/popup/model/subscription.js
// module id = 131
// module chunks = 0